import { debounce } from 'lodash';
import { IReactionDisposer, observable, reaction } from 'mobx';
import { Clazz, deserialize, serialize } from 'serializr';
import { UserSettings } from 'tools/userSettings';

type GetSettingsProps<T extends object> = {
	clazz?: Clazz<T>;
	trackable?: boolean;
	ignoreCache?: boolean;
};

export async function getSettings<T extends object>(category: string, props?: GetSettingsProps<T>) {
	const settings = (await UserSettings.getCategory(category, props?.ignoreCache)) as T;

	const settingsClassInstance = props?.clazz
		? deserialize(props.clazz, settings)
		: observable(JSON.parse(JSON.stringify(settings)) as T);

	const updateSettingsDebounced = debounce((updatedSettings) => {
		void UserSettings.set(category, updatedSettings, true);
	}, 1000);

	let disposer: IReactionDisposer;
	if (props?.trackable !== false) {
		disposer = reaction(
			() =>
				props?.clazz
					? (serialize(props.clazz, settingsClassInstance) as T)
					: (JSON.parse(JSON.stringify(settingsClassInstance)) as T),
			(i) => {
				updateSettingsDebounced(i);
			},
		);
	}

	return { data: settingsClassInstance, destroy: disposer };
}

export async function saveSettings(category: string, settings: unknown) {
	await UserSettings.set(category, settings, true);
}
